import HasRole from "modules/5_view_helpers/HasRole";
import { canImportClaims, canUseClaims } from "modules/administration/claims/access";
import { createCustomFormLinks, createMenuItems } from "../helpers";

const getAdministrationNav = (administration_custom_forms, administration_menus) => {
  const AutomatedInvoiceRoles = HasRole({ resource_type: "Administration::AutomatedInvoice" });
  const ClaimRoles = canUseClaims();
  if (AutomatedInvoiceRoles || ClaimRoles || _.isNotEmpty(administration_custom_forms) || _.isNotEmpty(administration_menus)) {
    let adminMenu = { icon: "fa fa-book", label: "Administration", content: [] };
    if (AutomatedInvoiceRoles) {
      adminMenu?.content?.push({ label: "Automated Invoices", to: "/administration/automated_invoices" });
    }
    if (ClaimRoles) {
      adminMenu?.content?.push({ label: "Claims", to: "/administration/claims" });
    }
    if (canImportClaims()) {
      adminMenu?.content?.push({ label: "Import claims", to: "/administration/claim_imports" });
    }
    adminMenu.content = _.concat(
      adminMenu?.content,
      createCustomFormLinks(administration_custom_forms),
      createMenuItems(administration_menus)
    );
    return adminMenu;
  }
};

export default getAdministrationNav;
